import DB from '../../DAL/DB'
import {baseStore} from './utilities'
import {auth} from '../../Auth'
import SystemLogger from '../../SystemLogger'

const forms = new DB.Forms()

export default function formLogo(parentID, state, dispatch) {
  // Only allow PNGs for logos
  for (let file of state.files) {
    if (file.type !== `image/png`) {
      const logger = new SystemLogger({uid: parentID, path: `/forms/${parentID}`})
      logger.event(`tried to upload a non-PNG logo, logo type is ${file.type}; canceling`, null, 5, {
        [auth.sunkaizenUser.id]: auth.sunkaizenUser.type,
      })
      return {store: {}, saveToDB: () => null}
    }
  }

  async function saveToDB(metadata) {
    await forms.update(parentID, null, {testing: 'testing', logo: metadata})
  }
  const store = baseStore(`forms/${parentID}/logo/`)

  return {store, saveToDB}
}
